import gql from 'graphql-tag';

export default gql`
  fragment preleadProjectGroupCustomizeItemNumberFragment on PreleadProjectGroupCustomizeItemNumber {
    id
    value
    projectGroupPreleadCustomizeItemId
  }
`;
